module.exports = __webpack_public_path__ + "static/media/pepehousing.5b4c1df0.jpg";